import * as Sentry from "@sentry/tanstackstart-react";
import { createRouter as createTanStackRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

let sentryInitialized = false;

export function getRouter() {
  const router = createTanStackRouter({
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    routeTree,
    scrollRestoration: true
  });

  initializeClientSentry(router);

  return router;
}

function initializeClientSentry(router: unknown) {
  if (sentryInitialized || typeof window === "undefined") {
    return;
  }

  const dsn = optionalEnv(import.meta.env.VITE_SENTRY_DSN);
  if (!dsn) {
    return;
  }

  const release = optionalEnv(import.meta.env.VITE_SENTRY_RELEASE);
  sentryInitialized = true;
  Sentry.init({
    dsn,
    environment: optionalEnv(import.meta.env.VITE_SENTRY_ENVIRONMENT) ?? import.meta.env.MODE,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(
        router as Parameters<typeof Sentry.tanstackRouterBrowserTracingIntegration>[0]
      )
    ],
    ...(release ? { release } : {}),
    sendDefaultPii: false,
    tracesSampleRate: parseSentrySampleRate(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE, 0.1)
  });
}

function optionalEnv(value: string | undefined) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

function parseSentrySampleRate(value: string | undefined, fallback: number) {
  const trimmed = optionalEnv(value);
  if (!trimmed) {
    return fallback;
  }

  const parsed = Number.parseFloat(trimmed);
  return Number.isFinite(parsed) ? Math.min(1, Math.max(0, parsed)) : fallback;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
